import styled from "styled-components";
import ArrowDown from '../../../assets/icons/icon-arrow-down-circle-gray.png'
import { theme } from "../../../styles/theme";

export const Container = styled.div`
    width: 100%;
    height: 100%;
    padding: 1.5rem;
    padding-top: 3rem;
    max-height: 20.625rem;
    min-height: 20.625rem;
    max-width: 20.625rem;

    display: flex;
    
    border-radius: 1rem;
    justify-content: center;
    background-color: #F8F8F9;

    @media (max-width: 1320px) {
        max-width: 100%;
        padding-top: 1rem;
    }

    @media (max-width: 768px) {
        max-width: 100%;

        
        justify-content: center;
    }

    @media (max-width: 400px) {
        padding-top: 2rem;
        min-height: fit-content;
    }
`;

export const Wrapper = styled.div`
    width: 100%;
    
    display: flex;
    flex-direction: column;
    justify-content: ${isCardLoading => isCardLoading ? 'center' : 'flex-start'};
`;

export const ProfileCircle = styled.div`
    width: auto;
    height: auto;
    position: relative;
    
    gap: 0.5rem;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const InitialsCircle = styled.div`
    width: 2rem;
    height: 2rem;
    left: ${({ selectImage }) => selectImage ? 'calc(50% - 6rem)' : 'calc(50% - 6rem)'};
    top: 0.9rem;
    position: absolute;
    
    display: flex;
    align-items: center;
    justify-content: center;
    
    color: white;
    font-size: 1rem;
    font-weight: bold;
    border-radius: 50%;
    background-color: ${theme.colors.gray.Cinza_2};
`;

export const Profile = styled.div`
    width: ${({ selectImage }) => selectImage ? '13.3125rem' : '12rem'};
    height: ${({ center }) => center ? '40px' : 'auto'};
    padding: 0.5rem 0.5rem 0.5rem 0.25rem;
    
    gap: 0.5rem;
    display: flex;
    cursor: ${({ disabled }) => disabled ? 'auto' : 'pointer'};
    margin-top: 0.4rem;
    align-items: center;
    justify-content: ${({ center }) => center ? 'center' : 'flex-start'};
    
    border-radius: 10rem;
    background-repeat: no-repeat;
    background-color: #F3F3F5;
    background-size: 1rem;
    background-image: ${({ selectImage }) => selectImage ? `url("${ArrowDown}")` : 'none'};
    background-position: ${({ selectImage }) => selectImage ? 'right 1.188rem center' : 'none'};

    > img {
        width: 2rem;
        height: 2rem;
        border-radius: 10rem;
    }

    > p {
        color: ${theme.colors.gray.Cinza_2};
        cursor: ${({ disabled }) => disabled ? 'auto' : 'pointer'};
        font-weight: 800;
        font-size: 0.5625rem;
        letter-spacing: 0.1rem;
        line-height: 0.84375rem;
        font-family: "Lato", Sans-serif;
    }

    select {
        width: 8rem;
        height: 2rem;
        
        position: relative;
        margin-left: ${({ selectImage }) => selectImage ? 'calc(50% - 3.438rem)' : 'calc(50% - 3.05rem)'};

        text-align: center;
        border: 0;
        cursor: pointer;
        color: ${theme.colors.gray.Cinza_2};
        font-weight: 800;
        appearance: none;
        font-size: 0.5625rem;
        letter-spacing: 0.1rem;
        text-transform: uppercase;
       
        font-family: 'Lato', sans-serif;
        background-color: transparent;

        /* Novos ajustes para o nome muito longo */
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &:disabled {
            cursor: auto;
            opacity: 1;
        }
    }
`;

export const ArrowIcon = styled.img`
    width: 1rem !important;
    height: 1rem !important;
    flex-shrink: 0;
    margin-left: auto;
    margin-right: 0.5rem;
    transition: transform 0.2s ease;
    transform: ${({ isOpen }) => isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
`;

export const SelectedLabel = styled.div`
    width: auto;
    max-width: 13rem;
    height: 2rem;
    min-width: 0;
    
    position: relative;
    padding-left: ${({ selectImage }) => selectImage ? 'calc(50% - 3.1rem)' : 'calc(50% - 3.05rem)'};

    display: block;
    line-height: 2rem;

    text-align: left;
    border: 0;
    cursor: ${({ disabled }) => disabled ? 'auto' : 'pointer'};
    color: ${theme.colors.gray.Cinza_2};
    font-weight: 800;
    appearance: none;
    font-size: 0.5625rem;
    letter-spacing: 0.1rem;
    text-transform: uppercase;
   
    font-family: 'Lato', sans-serif;
    background-color: transparent;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const ButtonProfile = styled.button`
    all: unset;
    display: flex;
    cursor: pointer;
    align-items: center;
`;

export const SelectOptions = styled.div`
    width: ${({ selectImage }) => selectImage ? '13.3125rem' : '12rem'};
    top: calc(100% + 0.5rem);
    left: 50%;
    z-index: 10;
    position: absolute;
    transform: translateX(-50%);

    display: flex;
    flex-direction: column;
    background: white;
    border-radius: 0.625rem;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
`;

export const SearchInputContainer = styled.div`
    width: 100%;
    padding: 0.625rem;
    border-bottom: 1px solid #eee;

    input {
        width: 100%;
        padding: 0.5rem;
        border: 1px solid #E0E0E0;
        border-radius: 0.5rem;
        font-size: 0.875rem;
        color: ${theme.colors.gray.Cinza_2};
        outline: none;
    }
`;

export const OptionsList = styled.div`
    max-height: 12rem;
    overflow-y: scroll;
    overflow-x: hidden;

    &::-webkit-scrollbar {
        width: 0.2rem;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.2);
        border-radius: 1rem;
    }
`;

export const Option = styled.div`
    padding: 0.625rem;
    cursor: pointer;
    transition: 0.3s;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 0.8rem;
    text-align: start;
    word-break: break-word;

    background: ${(props) => (props.selected ? "#eee" : "transparent")};

    &:hover {
        background: #eee;
    }
`;

export const EmptyOption = styled.div`
    padding: 0.625rem;
    font-size: 0.8rem;
    color: #666;
`;

export const CirclesContainer = styled.div`
    width: 100%;
    height: ${({isCardLoading}) => isCardLoading ? '100%' : 'auto'};

    display: flex;
    justify-content: center;
    margin-bottom: ${({marginBottom, isCardLoading}) => marginBottom ? marginBottom : '2rem'};
`;

export const CircleData = styled.div`
    height: ${({notFound}) => notFound ? '175px' : 'fit-content'};

    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: ${({notFound}) => notFound ? 'center' : 'normal'};

    >p{
        text-align: center;
    }
    
    @media (max-width: 400px) {
        display: flex;
        align-items: center;
    }
`;

export const CircleTRT = styled.div`
    flex-direction: column;

    >p{
        text-align: center;
    }
    
    @media (max-width: 400px) {
        display: flex;
        align-items: center;
    }
`;

export const NotFound = styled.div`
    width: 100%;

    gap: 0.5rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    >img{
        width: 100%;
        height: auto;
        max-width: 80px;

        margin-top: 2.5rem;
    }`
export const ContainerNorFound = styled.div`
    width: 100%;
    height: 230px;

    gap: 0.5rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    >img{
        width: 80px;
        height: auto;
    }

    >span{
        text-align: center;
    }
`;